export default __webpack_public_path__ + "static/media/icon-appointment-time.99724e56.svg";